import { I18nManager } from "react-native";
import variable from "./../variables/platform";

export default (variables = variable) => {
  const inputTheme = {
    ".multiline": {
      height: 120,
      textAlignVertical: "top"
    },
    ".reportissue": {
      height: 130,
      textAlign: I18nManager.isRTL ? "right" : "left"
    },
    height: variables.inputHeightBase,
    color: variables.inputColor,
    paddingLeft: 5,
    paddingRight: 5,
    flex: 1,
    fontSize: variables.inputFontSize,
    lineHeight: variables.inputLineHeight
  };

  return inputTheme;
};
